// extracted by mini-css-extract-plugin
export default {"keys__key":"lsf-keys__key","keys__key-group":"lsf-keys__key-group"};
    if(module.hot) {
      // 1637785517370
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  